import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { Dispatch } from "redux";
import { State } from "redux/state";

import {
    NotificationsView,
    NotificationsViewDispatchProps as DispatchProps,
    NotificationsViewOwnProps as OwnProps,
    NotificationsViewStateProps as StateProps
} from "../components/NotificationsView";

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch: Dispatch) => {
    return {};
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => {
    const { notification } = state.layout;

    return {
        notification
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationsView);
